/*
 * @Author: Qzx
 * @Date: 2020-04-01 11:44:55
 * @Description: 项目相关配置信息
 * @LastEditors: Qzx
 * @LastEditTime: 2020-04-14 12:23:30
 */
export default {
  eventid: 'summerCamp', // 项目唯一标识
  appid: '1001132', // 项目唯一标识
  sGroupId: '691001', // 活动唯一标识
  projectName: 'summerCamp', // 活动名称
  description: '2021 暑期笔尖少年', // 项目相关描述
  developer: 'muguangfeng wangxin35', // 参与项目开发者
  xesShare: {
    title: '书写夏天，赢取好礼', // 标题
    desc: '写作夏令营，快乐嗨不停', // 描述
    link: 'https://t.xueersi.com/gMsT0lMR', // 链接
    imgUrl: 'https://editor.xesimg.com/tailor/resource/b2eabae2-32ec-4949-a305-c84998bc28a41-1623132898685.jpg' // 图标
  }, // 活动分享相关
  xesLog: {
    pages: {
      home: {
        uid: 'page1',
        name: '活动首页',
        level: 1
      },
      articleDetail: {
        uid: 'articleDetail',
        name: '文章详情页',
        level: 1
      },
      apply: {
        uid: 'apply',
        name: '报名页',
        level: 1
      },
      helpPage: {
        uid: 'helpPage',
        name: '助力页',
        level: 1
      },
      personalList: {
        uid: 'personalList',
        name: '往期征文',
        level: 1
      },
      addAddress: {
        uid: 'addAddress',
        name: '填写地址页',
        level: 1
      },
      articleUpload: {
        uid: 'articleUpload',
        name: '上传作文页',
        level: 1
      }
    }
  } // 日志打点相关(展现)
}
